import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { PrincipalService } from '../../core/services/principal.service';
import { menuOption } from 'src/app/core/constants/nav.constants';
import { RouteUtilService } from 'src/app/shared/utils/route-util.service';
import { filter } from 'rxjs/operators';
import { AlertService } from 'src/app/modules/alerts/alert.service';
import { IResponse } from 'src/app/shared/models/app';
import { UserService } from 'src/app/core/services/user.service';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { AlertsRoutes } from 'src/app/core/constants/route.constant';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import { AccountTypes, AppConstant, RoleCodes } from 'src/app/core/constants/app.constant';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
    selector: 'nuctrac-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {
  /*********************Properties*********************/
  faBars = faBars;
  menuOption = menuOption;
  menuOptionDisplay: any[] = [];
  menuList: any;
  showSubMenu: boolean = false;
  Url: any;
  alerts: any[] = [];
  alertCount: number = 0;
  isHighAlert: boolean = false;
  showMenubar = false;
  selectedIndex: any = null;
  private subscription = {
    authenticated: null,
    reservation: null,
    alertCounter: null,
    orderDataLoaded: null
  } as any;
  reservationCount: any;
  isOrderStubEnabled: any = false;
  isMobileView!: boolean;
  isMenuDisabled: boolean = false;
  isEnrollmentRequired: boolean = false;
  noRoleAssignStatus = AppConstant.Messages.AccountRoles;
  userRoleDetails: any;
  assignedWORole: any;
  assignedInvoiceRole: any;
  isReadonlyUserRole: any;
  isInvoiceUserRole: any;
  isBuyerUserRole: any;


  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService,
    private userService: UserService,
    private routeUtilService: RouteUtilService,
    private cacheService: CacheResolverService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e: any) => {
        if (this.menuList != undefined) {
          for (let i = 0; i < this.menuList.length; i++) {
            if (this.menuList[i].url == e.url) {
              this.selectedIndex = i;
            }
          }
        }
      });
      this.assignedWORole = this.userService.getUserAssignedRole(AccountTypes.NPSWO);
      this.assignedInvoiceRole = this.userService.getUserAssignedRole(AccountTypes.Invoice);
      this.isReadonlyUserRole = this.userService.hasUserRoleAssigned(RoleCodes.ReadOnly);
      this.isInvoiceUserRole = this.userService.hasUserRoleAssigned(RoleCodes.Invoice);
      this.isBuyerUserRole = this.userService.hasUserRoleAssigned(RoleCodes.Buyer);
  }
  /*********************Constructor*********************/

  /*********************Lifecyle Methods*********************/
  ngOnInit() {
    this.userRoleDetails = this.cacheService.get(CacheConstant.LocalStorage.NoRoleAssigned)
    this.subscription.alertCounter = this.alertService.alertCount$.subscribe(
      (count) => {
        this.alertCount = count;
      }
    );
    this.subscription.reservation = this.alertService.reservationsUpdate$.subscribe(
      (data) => {
        this.onReservationUpdate(data);
      }
    );

    // if (this.cacheService.get(CacheConstant.LocalStorage.OrderDataLoaded).isOrderDataLoaded) {
    //   this.isMenuDisabled = false;
    //   this.isMenuDisabled = false;
    // }
    // else {
    //   this.isMenuDisabled = true;
    //   this.reservationCount = 0;
    //   this.isOrderStubEnabled = false;
    //   this.alertCount = 0
    // }

    this.subscription.orderDataLoaded = this.accountService.orderDataLoaded$.subscribe(
      (resp: IResponse) => {
       if(resp.hasError)
       {
          this.isMenuDisabled = true;
          this.reservationCount = 0;
          this.isOrderStubEnabled = false;
          this.alertCount = 0
       }
       else{
        this.isMenuDisabled = false;
         this.isEnrollmentRequired = this.cacheService.get(CacheConstant.LocalStorage.CustomerAdminSettings)?.isPatientEligibilityRequired;
         this.menuOptionDisplay = this.menuOption;
         this.menuList = this.menuOptionDisplay.filter(
           (option) => option.config.displayBottom === false
         );
         this.menuList.forEach((menu: any) => {
           if(menu.src == 'menu_patient_enrollment' && !this.isEnrollmentRequired){
             menu.isMenuVisible = false;
           }
           if(menu.src == 'menu_patient_enrollment' && this.isEnrollmentRequired){
             menu.isMenuVisible = true;
           }
         })
       }
      }
    );
    this.isEnrollmentRequired = this.cacheService.get(CacheConstant.LocalStorage.CustomerAdminSettings)?.isPatientEligibilityRequired;
    this.menuOptionDisplay = this.menuOption;
    this.menuList = this.menuOptionDisplay.filter(
      (option) => option.config.displayBottom === false
    );

    this.menuList.forEach((menuOption: any) => {

      if (this.isReadonlyUserRole) {
        if (this.assignedInvoiceRole) {
          if (menuOption.src != 'menu_report') {
            menuOption.isMenuVisible = false;
          }
        }
      }
      else if (this.assignedInvoiceRole && !this.assignedWORole) {
        if (menuOption.src != 'menu_report') {
          menuOption.isMenuVisible = false;
        }

      }
      // if(this.isReadonlyUserRole && menuOption.src != 'menu_home' &&  menuOption.src != 'menu_report')
      // {
      //   menuOption.isMenuVisible = false;
      // }
      if (this.isBuyerUserRole && menuOption.name == 'accountSetting') {
        menuOption.isMenuVisible = false;
      }
      if(menuOption.src == 'menu_patient_enrollment' && !this.isEnrollmentRequired){
        menuOption.isMenuVisible = false;
      }

    });


    //detect screen size
    this.breakpointObserver
      .observe([
        Breakpoints.Handset,
        Breakpoints.HandsetPortrait,
        Breakpoints.HandsetLandscape,
        Breakpoints.Tablet,
        Breakpoints.TabletPortrait,
        Breakpoints.TabletLandscape,
      ])
      .subscribe((result: BreakpointState) => {
        if (result.matches) {
          this.isMenuDisabled = true;
        } else {
          this.isMenuDisabled = false;
        }
      });
  }

  onReservationUpdate(data: any) {
    if (data) {
      this.reservationCount = data.reservationCount;
      this.isOrderStubEnabled = data.isOrderStubEnabled;
    }
  }

  /*********************Lifecyle Methods*********************/

  /*********************Component Methods*********************/

  onMainMenuClicked(event: any, currentIndex: any) {
    this.selectedIndex = currentIndex;

    this.Url = this.menuOptionDisplay[currentIndex].url;
    if (!this.isMenuDisabled) {
      if (this.menuOptionDisplay[currentIndex].subItems.length == 0) {
        this.router.navigateByUrl(this.Url);
        this.collapseAnother(currentIndex);
        if (this.isMobileView) {
          this.onOpenCloseMenuClick();
        }
      } else {
        event.stopPropagation();
        this.menuList[currentIndex].config.highlight = true;
        this.menuList[currentIndex].config.showSubMenu = !this.menuList[
          currentIndex
        ].config.showSubMenu;
        this.collapseAnother(currentIndex);

        if (currentIndex == 2) {
          if (!this.isInvoiceUserRole) {
            this.menuOptionDisplay[currentIndex].subItems = this.menuOptionDisplay[currentIndex].subItems.filter((objS: any) => objS.name != 'invoices')
          }
          else if (this.isInvoiceUserRole && this.isReadonlyUserRole) {
            this.menuOptionDisplay[currentIndex].subItems = this.menuOptionDisplay[currentIndex].subItems.filter((objS: any) => objS.name == 'invoices')
          }
          else if (this.assignedInvoiceRole && !this.assignedWORole) {
            this.menuOptionDisplay[currentIndex].subItems = this.menuOptionDisplay[currentIndex].subItems.filter((objS: any) => objS.name == 'invoices');
          }
        }

        if (currentIndex == 4) {
          if (!this.isOrderStubEnabled) {
            this.menuOptionDisplay[currentIndex].subItems = this.menuOptionDisplay[currentIndex].subItems.filter((objS: any) => objS.name == 'alerts');
          }
          else {
            if (this.menuOptionDisplay[currentIndex].subItems.length == 1) {
              this.menuOptionDisplay[currentIndex].subItems[1] = {
                title: 'Reservation',
                name: 'reservation',
                url: AlertsRoutes.Reservations.Url,
                isMenuVisible: true,
                config: { highlight: false },
              };
            }
          }
        }
      }
    }

  }

  collapseAnother(index: any) {
    this.menuList.forEach((el: any, i: any) => {
      if (i != index) {
        this.menuList[i].config.showSubMenu = false;
      }
    });
  }

  collapseAll() {
    this.menuList.forEach((el: any) => {
      el.config.highlight = false;
      if (el.config.subMenu) {
        el.config.showSubMenu = false;
      }
      el.config.isMenuVisible = false;
      if (el.subItems) {
        el.subItems.forEach((submenu: any) => {
          submenu.showSubMenuItems = false;
        });
      }
    });
  }

  onSubItemClicked(subItem: any) {
    this.Url = subItem.url;
    this.router.navigateByUrl(this.Url);
    this.collapseAll();
    if (this.isMobileView) {
      this.onOpenCloseMenuClick();
    }
  }

  onSubMenuItemClicked(subMenu: any) {
    this.collapseAll();
    this.Url = subMenu.url;
  }

  onOpenCloseMenuClick() {
    this.showMenubar = !this.showMenubar;
  }

  showLeftNavigationBar() {
    var showNavbar = true;

    if (!this.assignedInvoiceRole && this.assignedWORole
      && RoleCodes.ReadOnly == this.assignedWORole.roleNum) {
      showNavbar = false;
    }

    return showNavbar;
  }

  /*********************Component Methods*********************/

  /*********************Private Methods*********************/

  /*********************Private Methods*********************/
}
